import { render, staticRenderFns } from "./EmailUnsubscribeLanding.vue?vue&type=template&id=82e16b02&scoped=true&"
import script from "./EmailUnsubscribeLanding.vue?vue&type=script&lang=js&"
export * from "./EmailUnsubscribeLanding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82e16b02",
  null
  
)

export default component.exports